/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const ADD_GREETING_CARD_GIFT_MESSAGE = 'mbp-checkout/ADD_GREETING_CARD_GIFT_MESSAGE';

export default {};
